export default __webpack_public_path__ + "static/media/rank_4.5c4a8060.svg";